import { createTheme } from "@material-ui/core/styles"
import { red, green } from "@material-ui/core/colors"
// import { kanitLight, kanitRegular, kanitMedium, kanitSemiBold, kanitBold, kanitExtraBold, kanitBlack } from "./theme"

// Edit MUI theme
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#092B40",
    },
    secondary: {
      main: "#F25835",
    },
    success: {
      main: green.A700,
    },
    error: {
      main: red.A700,
    },
    background: {
      default: "#FFF",
    },
  },

  // overrides: {
  //   MuiCssBaseline: {
  //     "@global": {
  //       "@font-face": [
  //         { ...kanitLight, fontDisplay: "swap" },
  //         { ...kanitRegular, fontDisplay: "swap" },
  //         { ...kanitMedium, fontDisplay: "swap" },
  //         { ...kanitSemiBold, fontDisplay: "swap" },
  //         { ...kanitBold, fontDisplay: "swap" },
  //         { ...kanitExtraBold, fontDisplay: "swap" },
  //         { ...kanitBlack, fontDisplay: "swap" },
  //       ],
  //     },
  //   },
  // },
})

export default theme
